import { MarketDetailsSkeleton } from './components/skeleton/MarketDetailsSkeleton'
import { useMarketDetails } from './logic/useMarketDetails'
import { MarketDetailsView } from './views/MarketDetailsView'
import { useConnectModal } from '@/domain/hooks/wallet'
import { withSuspense } from '@/ui/utils/withSuspense'

function MarketDetailsContainer() {
  const { openConnectModal = () => {} } = useConnectModal()
  const marketDetails = useMarketDetails()

  return <MarketDetailsView openConnectModal={openConnectModal} {...marketDetails} />
}

const MarketDetailsContainerWithSuspense = withSuspense(MarketDetailsContainer, MarketDetailsSkeleton)
export { MarketDetailsContainerWithSuspense as MarketDetailsContainer }
